<form class="relative dialog-wrapper p-1" data-test-id="dialog_request_name" [formGroup]="form" (submit)="onSubmit()">
  <button
    type="button"
    class="reset-button absolute t-0 r-0 icon icon-close close"
    (click)="onClose()"
    data-test-id="button_close_dialog"
  ></button>

  <h3 mat-dialog-title class="medium color-black">
    {{ 'module.substitute.text.edit-substitution' | translate }}
  </h3>

  <div class="pb-1q">
    <app-edit-substitute-form
      optionValue="value"
      selectClass="w-100"
      testId="substitute_fieldset"
    ></app-edit-substitute-form>
  </div>

  <mat-dialog-actions>
    <div class="w-100 row p-0">
      <div class="col-6 p-0 pr-1">
        <button
          class="button primary-button w-100 d-flex align-items-center justify-content-center"
          type="submit"
          data-test-id="button_add"
          [disabled]="form.invalid || (loading$ | async)"
        >
          <div class="spinner-wrapper" *ngIf="loading$ | async">
            <span class="spinner spinner-bounce-middle"></span>
          </div>
          <span>{{ 'common.button.edit' | translate }}</span>
        </button>
      </div>
      <div class="col-6 p-0 pl-1">
        <button class="button secondary-button w-100" (click)="onClose()" data-test-id="edit_substitute_cancel" type="button">
          {{ 'common.button.cancel' | translate }}
        </button>
      </div>
    </div>
  </mat-dialog-actions>
</form>
